<script>
import SelectCountries from '@/views/Goods/SelectCountries'
import SelectSites from '@/views/Goods/SelectSites'
import gql from 'graphql-tag'

export default {
  components: {
    SelectCountries,
    SelectSites
  },
  data() {
    return {
      error: null,
      filter: {
        countryID: null,
        siteID: null,
      },
      table: null
    }
  },
  methods: {
    async changeActivity(paymentInMethodID, activity) {
      if (confirm('Поменять активность шлюза?') !== true) {
        return false
      }

      try {
        await this.$apollo.mutate({
          mutation: gql`mutation paymentChangeActivity($activity: Boolean!, $countryID: Int!, $paymentInMethodID: Int!, $paymentSiteID: Int!) {  paymentChangeActivity(paymentInMethodID: $paymentInMethodID, activity: $activity, paymentSiteID: $paymentSiteID, countryID: $countryID)}`,
          variables: {
            paymentInMethodID: paymentInMethodID,
            activity: activity,
            paymentSiteID: this.filter.siteID,
            countryID: this.filter.countryID,
          },
        })
      } catch (err) {
        this.error = 'Ошибка при обновлении активности шлюза: ' + err
      }

      await this.$apollo.queries.paymentMethods.refetch()
    },
    countryIDChanged(v) {
      this.filter.countryID = v
      this.$apollo.queries.paymentMethods.refetch()
    },
    siteIDChanged(v) {
      this.filter.siteID = v
      this.$apollo.queries.paymentMethods.refetch()
    }
  },
  computed: {
    computedItems() {
      return this.paymentMethods ? this.paymentMethods : []
    },
    hasItems() {
      return this.paymentMethods != null && this.paymentMethods.length > 0
    },
  },
  apollo: {
    paymentMethods: {
      query: gql`query paymentMethods($filter: FilterPaymentMethods!) {  paymentMethods(filter: $filter) { id    active    name    desc  }}`,
      variables() {
        return {
          filter: {
            countryID: this.filter.countryID,
            paymentSiteID: this.filter.siteID,
          }
        }
      },
      skip() {
        return (!this.filter.countryID || !this.filter.siteID)
      },
      error(err) {
        this.paymentMethods = []
        this.error = err
      },
      client: 'private',
      update(data) {
        this.error = null
        return data.paymentMethods
      }
    },
  },
}
</script>

<template>
  <v-container>
    <portal to="pageTitle">
      <span>Шлюзы</span>
    </portal>

    <v-row align="center" class="mt-3">
      <v-col class="d-flex.align-center" cols="12" sm="6" lg="4">
        <SelectCountries :countryID="filter.countryID" @countryIDChanged="countryIDChanged"/>
      </v-col>
      <v-col class="d-flex.align-center" cols="12" sm="6" lg="4">
        <SelectSites :siteID="filter.siteID" @siteIDChanged="siteIDChanged"/>
      </v-col>
    </v-row>

    <div v-if="$apollo.loading">Loading...</div>
    <div v-if="error">LoadingError: {{ error }}</div>
    <v-card class="mx-auto" max-width="1200">
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">Название</th>
            <th class="text-left">Описание</th>
            <th class="text-left">Активность</th>
          </tr>
          </thead>

          <tbody v-if="hasItems && !$apollo.loading">
          <tr v-for="item in computedItems" :key="item.id">
            <td> {{ item.id }}</td>
            <td> {{ item.name }}</td>
            <td> {{ item.desc }}</td>
            <td>
              <v-btn
                :color="item.active?'primary':'normal'"
                elevation="1"
                @click="changeActivity(item.id, !item.active)">{{ item.active ? 'Да' : 'Нет' }}
              </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
</template>
